module.exports = __webpack_public_path__ + "img/cloud-download.12416c63.svg";